/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Verschwiegenheitsbogenerhalten1Inputs */

const de__field_verschwiegenheitsbogenerhalten1 = /** @type {(inputs: _Field_Verschwiegenheitsbogenerhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschwiegenheitserklärung erhalten`)
};

/**

* @param {_Field_Verschwiegenheitsbogenerhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_verschwiegenheitsbogenerhalten1 = /** @type {((inputs?: _Field_Verschwiegenheitsbogenerhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Verschwiegenheitsbogenerhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_verschwiegenheitsbogenerhalten1(inputs)
});
export { _field_verschwiegenheitsbogenerhalten1 as "_field_verschwiegenheitsbogenErhalten" }